
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-05-06-stencil-mask",
      function () {
        return require("private-next-pages/blogs/2025-05-06-stencil-mask/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-05-06-stencil-mask"])
      });
    }
  